/**
 * A store abstraction that falls back to in-memory storage
 * when localStorage is unavailable (e.g., in incognito mode, SSR, or when blocked by browser settings).
 */
export class LocalStorageStore {
	#inMemoryStorage: Record<string, string> = {};
	#inMemoryStorageUsed: boolean = false;

	/**
	 * Sets a value in store.
	 * @param key - The key to store the value under
	 * @param value - The value to store
	 */
	set(key: string, value: string): void {
		try {
			localStorage.setItem(key, value);
		} catch (e) {
			this.#inMemoryStorage[key] = value;
			this.#inMemoryStorageUsed = true;
		}
	}

	/**
	 * Gets a value from store.
	 * @param key - The key to retrieve the value for
	 * @returns The stored value, or null if not found
	 */
	get(key: string): string | null {
		try {
			if (!this.#inMemoryStorageUsed) return localStorage.getItem(key);
			else return this.#inMemoryStorage.hasOwnProperty(key) ? this.#inMemoryStorage[key] : null;
		} catch (e) {
		} finally {
			return this.#inMemoryStorage.hasOwnProperty(key) ? this.#inMemoryStorage[key] : null;
		}
	}

	/*
	 * Removes a value from store.
	 * @param key - The key to remove the value for
	 */
	remove(key: string): void {
		try {
			delete this.#inMemoryStorage[key];
			localStorage.removeItem(key);
		} catch (e) {}
	}
}
